import { constructUrl } from '@flicent/fieldpulse-react-component-library-frontend';

import { CustomFormPageUriParams } from '@/types';
import { ROUTE } from '@/constants';


export const constructCustomFormPageUrl = (uriParams: CustomFormPageUriParams): string => {
  return constructUrl<CustomFormPageUriParams>(ROUTE.customForm, uriParams);
};